import StepWizard, { StepWizardProps } from "react-step-wizard";

interface Props extends StepWizardProps {}

export default function PromineoStepWizard(props: Props) {
  return <StepWizard {...props} />;
}
